import type React from 'react';
import styled from '@emotion/styled';
import { TagDetailsSection } from './TagDetailsSection';
import { TagDetailField } from './TagDetailField';

export type TagDetailsInfoSectionProps = {
  /** tag.base.name */
  title: string;
  /** tag.base.tagCategory */
  tagCategory: string | null | undefined;
  /** formatted date string, e.g. "M/d/yyyy" */
  datePublished: string;
  /** "Parent ID: 123" or "None" */
  parentTag: string;
  /** tag.metadata.taggedMomentsCount */
  coverageCount: number;
  /**
   * Slot for the "Published Status" cell. Pass a custom node (e.g. a
   * PublishedSegments.Row for Segmentation tags, or a plain TagDetailField).
   */
  statusNode: React.ReactNode;
  /**
   * Slot for the "Color" cell. Pass a TagDetailsColorSelect (or read-only swatch).
   */
  colorNode: React.ReactNode;
  /** tag.base.lastModified formatted */
  lastModified: string;
  /** tag.includeSummary → "Yes" / "No" */
  includeInSummary: string;
};

export const TagDetailsInfoSection = ({
  title,
  tagCategory,
  datePublished,
  parentTag,
  coverageCount,
  statusNode,
  colorNode,
  lastModified,
  includeInSummary,
}: TagDetailsInfoSectionProps) => (
  <TagDetailsSection title="Tag Details">
    <GridRow>
      <TagDetailField label="Tag Title" value={title} />
      <TagDetailField label="Tag Category" value={tagCategory} />
      <TagDetailField label="Date Published" value={datePublished} />
    </GridRow>
    <GridRow>
      <TagDetailField label="Parent Tag" value={parentTag} />
      <TagDetailField label="Coverage Count" value={coverageCount} />
      {statusNode}
    </GridRow>
    <GridRow>
      {colorNode}
      <TagDetailField label="Last Modified" value={lastModified} />
      <TagDetailField label="Include in Summary" value={includeInSummary} />
    </GridRow>
  </TagDetailsSection>
);

TagDetailsInfoSection.displayName = 'TagDetails.InfoSection';

const GridRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
  padding: 12px 0;
`;
